export default "__VITE_ASSET__CbmK1bYa__"